<!-- Password strength indicator -->
<div *ngIf="password" class="password-strength-container">
  <div class="password-strength-bar">
    <div class="password-strength-progress" [ngClass]="passwordStrengthClass"></div>
  </div>
  <div class="password-strength-text" [ngClass]="passwordStrengthClass">
    {{ passwordStrengthText | transloco }}
  </div>
  <div class="password-requirements">
    {{ 'auth.register.passwordStrength.requirements' | transloco }}
  </div>
</div>
